<template>
	<v-app id="zarinpalCallback-view" fluid tag="section">
		<v-app-bar color="secondary" dark dense style="max-height: 48px">
			<a href="/" class="d-flex align-center">
				<img src="/logo-wide.png" style="max-width: 80px; max-height: 32px" class="hidden-sm-and-down" />

				<!-- نسخه کوچکتر برای موبایل -->
				<img src="/logo-wide.png" style="max-width: 60px; max-height: 28px" class="hidden-md-and-up" />
			</a>
			<div class="">
				<strong>بررسی اطلاعات جهت هدایت به درگاه پرداخت</strong>
				&nbsp;&nbsp;
				<span class="warning--text text-truncate">{{ longTitle }}</span>
			</div>
			<v-spacer />
			<v-btn color="#000" elevation="0" dark small @click="returnToPanel">
				<v-icon left color="#fff">mdi-account-outline</v-icon>
				ورود به پنل کاربری
			</v-btn>
		</v-app-bar>
		<v-container>
			<v-row justify="center" class="my-12">
				<v-col cols="12" md="6" v-if="loading || !isSuccess">
					<v-card class="mx-auto">
						<div class="d-flex flex-column justify-center align-center" style="height:200px;" :style="{ 'background-color': bg }">
							<v-icon size="large" :color="color" style="font-size: 100px;">
								{{ icon }}
							</v-icon>
						</div>
						<div class="form-group text-center pa-5">
							<div v-if="message" v-html="message">

							</div>
						</div>
					</v-card>
				</v-col>
			</v-row>
			<v-row class="justify-center" justify="center" v-if="!loading && isSuccess">
				<v-col cols="12" md="6">
					<v-card color="white" class="">
						<div class="form-group text-right pa-5">
							<div class="text-center pa-5">
								<v-btn fab color="secondary" elevation="0" x-large>
									<v-icon color="white">mdi-wallet-outline</v-icon>
								</v-btn>
							</div>
							<p class="text-body secondary--text" style="text-align: justify;">کاربر گرامی شما در حال آماده سازی جهت واریز وجه صورتحساب با مشخصات زیر هستید، لطفا پس از بررسی و اطمینان از صحت اطلاعات اقدام به پرداخت نمایید.</p>
							<div class="my-2">
								<span>پذیرنده:</span><span class="grey--text mr-2">{{ data.agent }}</span>
							</div>
							<div class="my-2">
								<span>مشخصات شما:</span><span class="grey--text mr-2">{{ data.member }}</span>
							</div>
							<div class="my-2">
								<span>شماره صورتحساب:</span><span class="grey--text mr-2">{{ data.agentFactorCode }}</span>
							</div>
							<v-divider />
							<div class="px-3 pt-3 rtl">
								<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
									<div>
										<div class="mb-1 red--text text-center">مبلغ قابل پرداخت صورتحساب (تومان):</div>
										<div class="pa-3 text-center" elevation="0" style="border-radius: 10px;border:1px solid red;color:red;font-size: 30px;">
											{{ data.agentFactorAmount.toString().toPriceFormat() }}
										</div>
									</div>
									<div class="pt-5 text-center">
										<v-btn @click="submit" color="secondary" class="w-100" :loading="submitLoading">
											<v-icon class="ml-2">mdi-credit-card</v-icon>
											پرداخت آنلاین
										</v-btn>
									</div>
								</v-form>
							</div>
						</div>
					</v-card>

				</v-col>
			</v-row>
		</v-container>
	</v-app>
</template>

<script>
import { get, call } from 'vuex-pathify'
import api from '@/util/app-api'
import ThemeManager from '@/util/theme-manager.js'
import toast from '@/util/toast'

const INVALIDMSG = 'اطلاعات معتبر نمی باشد'
export default {
	name: 'AgentFactorPrePayment',
	data() {
		return {
			userLoanPayment: null,
			errorMessages: '',
			data: { customerCode: 0, member: '', memberId: 0, agentId: 0, agentFactorAmount: 0, agentFactorId: 0, agentFactorCode: 0 },
			submitLoading: false,
			loading: false,
			isSuccess: null,
			message: ''
		}
	},
	computed: {
		...get('siteConfig', [
			'longTitle'
		]),
		...get('appSettings', [
			'landingSettings'
		]),
		bg() {
			if (this.loading)
				return '#dadada'
			if (this.isSuccess)
				return 'rgb(182 255 193)'
			return 'rgb(255 227 227)'
		},
		color() {
			if (this.loading)
				return '#aaa'
			if (this.isSuccess)
				return '#0dd400'
			return '#ff5722'
		},
		icon() {
			if (this.loading)
				return 'mdi-timer-sand'
			if (this.isSuccess)
				return 'mdi-credit-card-check'
			return 'mdi-alert-circle-outline'
		},
		title() {
			if (this.loading)
				return 'در حال بررسی'
			if (this.isSuccess)
				return 'پرداخت موفق'
			return 'پرداخت ناموفق'
		}
	},
	created() {

	},
	mounted() {
		if (!this.$route.query.customerCode || !this.$route.query.agentFactorCode) {
			this.message = INVALIDMSG
			return
		}
		this.verify()
		this.loadAppSettings({ force: true, customerCode: this.$route.query.customerCode })
	},
	methods: {
		loadAppSettings: call('appSettings/fetchLandingSettings'),
		verify() {
			this.message = 'در حال دریافت اطلاعات، لطفا تا پایان عملیات منتظر بمانید...'
			this.loading = true
			let data = {
				customerCode: this.$route.query.customerCode,
				agentFactorCode: this.$route.query.agentFactorCode
			}
			api.post('memberPurchase/PreAgentFactorPayment', data, { authHeader: false, contentType: 'application/json' })
				.then(response => {
					this.isSuccess = true
					this.data.customer = response.customer
					this.data.member = response.member
					this.data.memberId = response.memberId
					this.data.customerCode = response.customerCode
					this.data.agent = response.agent
					this.data.agentId = response.agentId
					this.data.agentFactorAmount = response.agentFactorAmount
					this.data.agentFactorId = response.agentFactorId
					this.data.agentFactorCode = this.$route.query.agentFactorCode
				})
				.catch(error => {
					this.isSuccess = false
					this.message = error.message || error.toString()
				})
				.finally(() => {
					this.loading = false
				})
		},
		returnToPanel() {
			this.$router.push('/member/dashboard')
		},
		submit() {
			if (!this.$refs.form.validate()) { return }
			this.submitLoading = true
			let data = {
				amount: this.data.agentFactorAmount,
				memberPurchaseType: 4,
				paymentMethod: this.landingSettings.agentFactorOnlinePaymentGateway,
				user: { id: this.data.memberId },
				customerCode: this.data.customerCode,
				agentFactor: { id: this.data.agentFactorId, code: this.data.agentFactorCode }
			}
			api.post('memberpurchase/create', data, { authHeader: false, contentType: 'application/json' })
				.then(response => {
					if (response.gateway === 'sep') {
						let form = document.getElementById('sepForm')
						let sepToken = document.getElementById('sepToken')
						sepToken.value = response.token
						form.submit()
					}
					else if (response.gateway === 'sepehr') {
						let form = document.getElementById('sepehrForm')
						let sepehrToken = document.getElementById('sepehrToken')
						sepehrToken.value = response.token
						let sepehrTerminal = document.getElementById('sepehrTerminalId')
						sepehrTerminal.value = response.terminalId
						form.submit()
					}
					else {
						window.location.replace(response.gatewayUrl)
					}
				})
				.catch(err => {
					this.submitLoading = false
					toast.error(err.message)
				})
		}
	},
}
</script>

<style scoped></style>
